var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('The404',[_c('h1',{staticClass:"mx-auto"},[_vm._v(_vm._s(_vm.$t('general.no-recipe-found')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }